import { PixiContainer } from "../PixiContainer";
import * as PIXI from 'pixi.js';
import HOITextHouseOfInnovation from "./HOITextHouseOfInnovation";
import Tween from "../../../tsunami/animation/Tween";
import TweenProperty from "../../../tsunami/animation/TweenProperty";
import Easing from "../../../tsunami/animation/Easing";
import Timeline from "../../../tsunami/animation/Timeline";

export default class HOITextHouseOf extends PixiContainer {

    constructor(style) {
        super();

        this.rectMask = new PIXI.Graphics();
        this.rectMask.beginFill(0xff0000, 1);
        this.addChild(this.rectMask);
        this.mask = this.rectMask;

        this.text1 = new PIXI.Text("HOUSE ", style);
        this.addChild(this.text1);

        this.text2 = new PIXI.Text("OF ", style);
        this.text2.x = this.text1.width;
        this.addChild(this.text2);

        this.text3 = new HOITextHouseOfInnovation(style);
        this.text3.x = this.text2.x + this.text2.width;
        this.addChild(this.text3);

        this.rectMask.drawRect(0, 0, this.text3.x + this.text3.width, this.text3.y + this.text3.height);

        this.showTimeline = new Timeline();
        this.showTimeline.add(new Tween(0, 1, [
            new TweenProperty(this.text1, "x", this.text1.x - this.text1.width, this.text1.x, Easing.cubic.easeOut),
            new TweenProperty(this.text2, "x", this.text1.x - this.text1.width - this.text2.width, this.text2.x, Easing.cubic.easeOut),
            new TweenProperty(this.text2, "alpha", 0, 1, Easing.linear.ease)
        ]));

        this.hideTimeline = new Timeline();
        this.hideTimeline.add(new Tween(0, 0.33, [
            new TweenProperty(this.text1, "x", this.text1.x, this.text1.x - this.text1.width, Easing.cubic.easeIn),
            new TweenProperty(this.text2, "x", this.text2.x, this.text1.x - this.text1.width - this.text2.width, Easing.cubic.easeIn),
            new TweenProperty(this.text2, "alpha", 1, 0, Easing.linear.ease)
        ]));

        this.text1.x = this.text1.x - this.text1.width;
        this.text2.x = this.text1.x + this.text1.width - this.text2.width;
    }

    showDelayComplete() {
        super.showDelayComplete();
        return Promise.all([
            this.showTimeline.start(),
            this.text3.show()
        ]);
    }

    hideDelayComplete() {
        return Promise.all([
            this.hideTimeline.start(),
            this.text3.hide()
        ]);
    }

}